import { useMutation, useQueryClient } from 'react-query';
import { ace_api } from '@axo/shared/data-access/api';
import { ace } from '@axo/shared/data-access/types';
import { useAPI } from '@axo/shared/data-access/provider';
import { callsKeys } from '../../cache-keys/callsKeys';

export function useToggleIsCallRecordAnswered() {
  const client = useQueryClient();
  const api = useAPI();

  return useMutation({
    mutationFn: ace_api.toggleIsCallRecordAnswered(api),
    onSuccess: (data) => {
      const queryKey = callsKeys.records({
        LoanApplicationID: data.LoanApplicationID,
      });

      return Promise.all([
        client.setQueryData<ace.FindCallRecordsResponse>(
          [queryKey],
          (oldData) => ({
            ...oldData,
            Items:
              oldData?.Items?.map((record) =>
                record.ID === data.ID ? data : record,
              ) ?? [],
          }),
        ),
      ]);
    },
  });
}
